import { FormattedMessage } from 'react-intl';
import { type DialogButtonProps } from './DialogButton';
import Dialog from '../..';

const DialogDeleteButton = ({ children, ...props }: DialogButtonProps) => (
  <Dialog.Actions.Button color="error" {...props}>
    {children ?? <FormattedMessage id="dialogs.actions.delete" />}
  </Dialog.Actions.Button>
);

export default DialogDeleteButton;
